<template>
    <div class="row">
        <div class="col px-1">
            <div class="wrapper-name">
                <span class="name let-space-1" @click="toPerson(item.user_id, item.name)">
                    <small>({{item.user_id}}){{item.name}}</small>
                </span>
                <span class="flex-fill text-right ml-2">
                    <i class="fas fa-user-alt" :class="{'text-success':item.status == '1'}"></i>
                    <span v-if="item.invited_cnt != 0" class="m-0 p-0" :class="{'text-success':item.child_active_cnt != 0}">
                        <i class="fas fa-angle-double-right"></i>
                        <span>
                            <small> {{item.child_active_cnt}}/{{item.invited_cnt}} </small>
                        </span>
                        <span @click="toTechChild(item.invite_code,item.name,item.level)">
                            <i class="fas fa-user-alt"></i>
                        </span>
                    </span>
                </span>
            </div>
            <div>
                <small class="d-flex">
                    <span v-if="item.cmp_group" class="text-nowrap">営：{{item.cmp_group}}</span>
                    <span v-if="item.sales_name" class="text-nowrap">/{{item.sales_name}}</span>
                    <span v-if="item.cmp_name" class="text-truncate">/{{item.cmp_name.replace('株式会社','㈱')}}</span>
                </small>
            </div>
            <div v-if="item.first_nm" class="let-space-1">
                <span>
                    <small>
                        <div>
                            {{item.first_nm}}&nbsp;{{item.last_nm}}&nbsp;({{item.first_kana}}&nbsp;{{item.last_kana}})&nbsp;
                        </div>
                        <div>
                            {{item.year}}/{{item.month}}/{{item.day}}&nbsp;&nbsp;
                            {{item.phone}}
                        </div>
                    </small>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            item: Object
        },
        methods: {
            toTechChild (code,name,level) {
                this.$parent.toTechChild(code,name,level)
            },
            toPerson (userId, name) {
                // TechLevel,TechChild両方から参照している
                this.$router.push({name:'TechDetail', params:{
                    userId: userId,
                    name: name
                }})
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import '~stylus/base/mixins.styl'
    .opacity0
        opacity: 0
    .wrapper-name
        display:flex
        white-space: nowrap
        .name
            ellipsis()
</style>
